import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// eslint-disable-next-line import/no-extraneous-dependencies
import { Combobox } from '@headlessui/react';
import clsx from 'clsx';
import { FaArrowRight, FaCheck, FaTimesCircle } from 'react-icons/fa';
import { ImSpinner2 } from 'react-icons/im';
import { getTestSelector } from '../../../utilities/tests';
var TypeaheadOption = function (_a) {
    var item = _a.item, selected = _a.selected, query = _a.query, testSelectorPrefix = _a.testSelectorPrefix, useRegexMatchReplacement = _a.useRegexMatchReplacement;
    return (_jsxs(Combobox.Option, { value: item, className: function (_a) {
            var active = _a.active;
            return clsx('text-sm flex items-center px-4 py-2.5 pr-2 m-0 transition-colors border-b border-gray-100 cursor-pointer last:border-b-0', active ? 'bg-oncolensBlue-500 text-white' : 'bg-white');
        }, "data-cy": getTestSelector(item.label, testSelectorPrefix), children: [_jsx(HighlightedText, { label: item.label, query: query, useRegexMatchReplacement: useRegexMatchReplacement }), item.alias && _jsx("span", { className: "px-3 italic text-gray-400", children: item.alias }), item.value === (selected === null || selected === void 0 ? void 0 : selected.value) && _jsx(FaCheck, { className: "w-3 h-3 ml-auto", "aria-hidden": "true" })] }));
};
var TypeaheadClearButton = function (_a) {
    var clearable = _a.clearable, selected = _a.selected, testSelector = _a.testSelector, setQuery = _a.setQuery, onChange = _a.onChange;
    return (_jsx(_Fragment, { children: clearable && selected && (_jsx("button", { className: "h-full", onClick: function () {
                setQuery('');
                onChange(null);
            }, "aria-label": "clear selection", "data-cy": "".concat(testSelector, "-clear-button"), children: _jsx(FaTimesCircle, { className: "box-content w-4 h-full px-2 text-gray-700" }) })) }));
};
var TypeaheadNoResultsPlaceholder = function (_a) {
    var isRemoteDataSource = _a.isRemoteDataSource, isLoading = _a.isLoading, isResolved = _a.isResolved, filteredData = _a.filteredData, query = _a.query, minRemoteQueryCharacters = _a.minRemoteQueryCharacters, noResultsLabel = _a.noResultsLabel;
    var showForLocalData = !isRemoteDataSource && filteredData.length === 0 && !!query;
    var showForRemoteData = isRemoteDataSource &&
        filteredData.length === 0 &&
        query.length >= minRemoteQueryCharacters &&
        !isLoading &&
        isResolved;
    return showForLocalData || showForRemoteData ? (_jsx(TypeaheadMessage, { children: noResultsLabel })) : null;
};
var TypeaheadRemoteSourcePlaceholder = function (_a) {
    var isLoading = _a.isLoading, isResolved = _a.isResolved, isRemote = _a.isRemote, label = _a.label;
    if (isRemote && isLoading) {
        return (_jsx(TypeaheadMessage, { children: _jsx(ImSpinner2, { className: "text-xl animate-spin" }) }));
    }
    if (isRemote && !isLoading && !isResolved) {
        return _jsx(TypeaheadMessage, { children: label });
    }
    return null;
};
var TypeaheadMessage = function (_a) {
    var children = _a.children;
    return (_jsx(Combobox.Option, { value: "", disabled: true, className: "flex items-center justify-center py-4 pr-2 m-0 text-sm bg-white border-b border-gray-100 last:border-b-0", children: children }, ""));
};
var TypeaheadCustomOption = function (_a) {
    var query = _a.query, testSelectorPrefix = _a.testSelectorPrefix, queryMatch = _a.queryMatch, allowCustomInput = _a.allowCustomInput, isResolved = _a.isResolved;
    return (_jsx(_Fragment, { children: allowCustomInput && !!query.trim() && isResolved && !queryMatch && (_jsxs(Combobox.Option, { value: { label: query, value: query, isCustom: true }, className: function (_a) {
                var active = _a.active;
                return clsx('text-sm flex items-center px-4 py-2.5 pr-2 m-0 transition-colors border-b border-gray-100 cursor-pointer last:border-b-0', active ? 'bg-oncolensBlue-500 text-white' : 'bg-white');
            }, "data-cy": getTestSelector('custom-option', testSelectorPrefix), children: ["Use custom value\u00A0", _jsx("strong", { children: query }), " ", _jsx(FaArrowRight, { className: "ml-auto" })] }, query)) }));
};
var HighlightedText = function (_a) {
    var label = _a.label, query = _a.query, useRegexMatchReplacement = _a.useRegexMatchReplacement;
    if (!query)
        return _jsx(_Fragment, { children: label });
    var cleanQuery = query.trim().toLowerCase();
    var searchString = useRegexMatchReplacement
        ? new RegExp(cleanQuery, 'ig')
        : label.substring(label.toLowerCase().indexOf(cleanQuery), cleanQuery.length + 1);
    var formattedHtml = label.replace(searchString, function (match) { return "<strong>".concat(match, "</strong>"); });
    return _jsx("span", { dangerouslySetInnerHTML: { __html: formattedHtml } });
};
export { TypeaheadOption, TypeaheadCustomOption, TypeaheadClearButton, TypeaheadNoResultsPlaceholder, TypeaheadRemoteSourcePlaceholder, };
